<template>
  <v-container fluid class="main-invest-container">
    <v-flex xs12 py-0>
      <span @click="onBackLink()" class="goback">{{$t('pagesInvest.deal.show.goBack')}}</span>
    </v-flex>
    <loading :text="$t('pagesInvest.deal.show.loading')" v-if="!isLoaded" />
    <v-layout row wrap text-center tender__not-found v-if="serverError">
      <v-flex xs12>
        <h1>{{ serverError }}</h1>
      </v-flex>
      <v-flex xs12 py-0>
        <v-divider />
      </v-flex>
    </v-layout>

    <div v-if="isLoaded && !serverError && offer">
      <v-layout row wrap>
        <v-flex xs12>
          <h1>{{$t('pagesInvest.deal.show.title')}}: {{ offer.offer.title }}</h1>
          <div class="subtitle1">{{ offer.offer.name }}</div>
        </v-flex>
        <v-flex xs12 py-0 mb-5>
          <v-divider />
        </v-flex>
      </v-layout>

      <v-layout row wrap v-if="fakeBid">
        <v-flex xs12>
          <h1>{{$t('pagesInvest.deal.show.negTitle')}}</h1>
        </v-flex>
        <v-flex xs12 py-0 mb-5>
          <v-divider />
        </v-flex>
        <v-flex xs12>
          <div class="block">
            <bid-chat :read-only="readOnlyChat" :bid="fakeBid" />
          </div>
        </v-flex>
      </v-layout>

      <v-flex xs12 py-0 mb-5 v-if="isShowActionButton">
        <v-flex xs12 py-0 mb-5>
          <v-divider />
        </v-flex>
        <v-flex xs12 py-0>
          <v-btn
            color="red lighten-1"
            dark
            x-large
            @click="openDeclineModal()"
            :loading="!isLoaded"
            :disabled="!isLoaded"
            class="mr-2"
            >{{$t('pagesInvest.deal.show.actions.decline')}}</v-btn
          >

          <v-btn
            class="mr-2"
            :loading="!isLoaded"
            :disabled="!isLoaded"
            color="orange"
            dark
            x-large
            v-if="isAgreedButton"
            @click="openNextStatusModal(10, $t('pagesInvest.deal.show.actions.agreedTitle'))"
            >{{$t('pagesInvest.deal.show.actions.agreed')}}</v-btn
          >

          <v-btn
            class="mr-2"
            :loading="!isLoaded"
            :disabled="!isLoaded"
            color="orange"
            dark
            x-large
            v-if="isPayedButton"
            @click="openNextStatusModal(30, $t('pagesInvest.deal.show.actions.payed'))"
            >{{$t('pagesInvest.deal.show.actions.payed')}}</v-btn
          >

          <v-btn
            class="mr-2"
            :loading="!isLoaded"
            :disabled="!isLoaded"
            color="green"
            dark
            x-large
            v-if="isCompleteButton"
            @click="openNextStatusModal(100, $t('pagesInvest.deal.show.actions.completeTitle'))"
            >{{$t('pagesInvest.deal.show.actions.complete')}}</v-btn
          >
        </v-flex>

        <v-flex xs12 py-0 my-5>
          <v-divider />
        </v-flex>
      </v-flex>

      <v-layout row wrap>
        <v-flex xs12>
          <h1>{{$t('pagesInvest.deal.show.info')}}</h1>
        </v-flex>
        <v-flex xs12 py-0 mb-5>
          <v-divider />
        </v-flex>
        <div xxxxs12 pa-0>
          <info-user-offer :invest="offer"></info-user-offer>
        </div>
      </v-layout>

      <v-layout row wrap mt-3 v-if="offer">
        <v-flex xs12 pt-0>
          <invest-info :offer="offer"></invest-info>
        </v-flex>
      </v-layout>

      <v-dialog v-model="nextStatusModal" max-width="600px" persistent>
        <v-layout row wrap modal__block>
          <span class="modal__close" @click="closeResultModal"></span>
          <v-flex xs12 modal__wrapper pt-10 style="min-height: 400px">
            <v-flex shrink>
              <textarea
                v-model="comment"
                outlined
                :label="$t('pagesInvest.deal.show.comment')"
                :placeholder="$t('pagesInvest.deal.show.comment')"
                filled
                class="show-offer-comment elevation-3 pa-2"
              ></textarea>
            </v-flex>
            <v-btn
              class="mt-5"
              :loading="!isLoaded"
              @click="sendConfirm"
              x-large
              style="color: white"
              color="deep orange"
              >{{ buttonName }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog v-model="declineModalShow" max-width="600px" persistent>
        <v-layout row wrap modal__block>
          <span class="modal__close" @click="closeResultModal"></span>
          <v-flex xs12 modal__wrapper pt-10 style="min-height: 400px">
            <v-flex shrink>
              <textarea
                v-model="comment"
                outlined
                :label="$t('pagesInvest.deal.show.actions.commentDecline')"
                :placeholder="$t('pagesInvest.deal.show.actions.commentDecline')"
                filled
                class="show-offer-comment elevation-3 pa-2"
              ></textarea>
            </v-flex>
            <v-btn
              class="mt-5"
              :loading="!isLoaded"
              @click="sendConfirm"
              :disabled="!comment"
              x-large
              style="color: white"
              color="red lighten-1"
              >{{$t('pagesInvest.deal.show.actions.decline')}}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import formatPrice from "@/mixins/filters/formatPrice";
//import formatNumber from "@/mixins/filters/formatNumber";
import formatDate from "@/mixins/filters/formatDate";
//import { mask } from "vue-the-mask";
import showNotify from "@/services/noty";
import statusNames from "@/utils/data/statuses";
import InvestInfo from "@/components/invest/Info";
import BidChat from "@/components/bids/chat";
import InfoUserOffer from "@/components/invest/InfoUserOffer";
//import wysiwyg from "vue-wysiwyg";
//Vue.use(wysiwyg, {});

export default {
  name: "InvestDealShow",
  //directives: { mask },
  mixins: [formatPrice, formatDate],
  data: () => ({
    isLoaded: false,
    offer: null,
    serverError: null,

    statusNames,

    status: null,
    comment: null,
    buttonName: null,
    declineModalShow: false,
    nextStatusModal: false,
  }),
  components: {
    BidChat,
    InvestInfo,
    InfoUserOffer,
  },

  computed: {
    ...mapState({
      userId: (state) => state.user.profile.id,
      userRole: (state) => state.user.profile.role,
    }),

    isShowActionButton() {
      if (this.offer) {
        //отказано
        if (this.offer.status == 40) return false;
        //выполнено
        if (this.offer.status == 100) return false;
      }
      //if(userRole != 100 &&)
      if (
        this.offer &&
        this.offer.offer &&
        this.offer.offer.user_created == this.userId
      )
        return true;
      return false;
    },

    isShowChat() {
      if (
        this.offer &&
        this.offer.offer &&
        this.offer.offer.user_created == this.userId
      )
        return true;
      if (this.offer && this.offer.user_id == this.userId) return true;

      return false;
    },

    fakeBid() {
      if (this.offer) {
        if (!this.isShowChat) return null;
        let tmpBid = Object.assign({}, this.offer);
        tmpBid.status = 60;
        return tmpBid;
      }
      return null;
    },

    readOnlyChat() {
      if (this.offer) {
        //отказано
        if (this.offer.status == 40) return true;
        //выполнено
        if (this.offer.status == 100) return true;
      }
      return false;
    },

    isAgreedButton() {
      if (this.offer) {
        //отказано
        if (this.offer.status == 1) return true;
      }
      return false;
    },

    isPayedButton() {
      if (this.offer) {
        //ожидает оплаты
        if (this.offer.status == 10) return true;
      }
      return false;
    },

    isCompleteButton() {
      if (this.offer) {
        //Завершенный
        if (this.offer.status == 30) return true;
      }
      return false;
    },
  },

  methods: {
    __clearModalVariable() {
      this.status = null;
      this.comment = null;
      this.buttonName = null;
    },
    openDeclineModal() {
      this.status = 40;
      this.declineModalShow = true;
    },
    openNextStatusModal(status, buttonName) {
      this.status = status;
      this.buttonName = buttonName;
      if (!this.buttonName) this.buttonName = "Button";
      this.nextStatusModal = true;
    },
    closeResultModal() {
      this.declineModalShow = false;
      this.__clearModalVariable();
    },
    onBackLink() {
      this.$router.go(-1);
      //this.$router.push({path: '/invest?tab=deals'});
    },
    async sendConfirm() {
      const url = `v1/invest/offers/${this.offer.offer.id}/deal/${this.offer.id}/result`;
      const data = { status: this.status, comment: this.comment };

      this.isLoaded = false;
      this.serverError = null;

      await apiCallTrue({ url, method: "POST", data })
        .then(() => {
          // this.offer = response.data.data;
          this.onBackLink();
        })
        .catch((error) => {
          console.log("ERROR", error);
          //this.serverError = error.message;
          showNotify("error", error);
        })
        .finally(() => {
          this.isLoaded = true;
        });
    },

    async getOffer(id) {
      const url = `v1/invest/offers/deal/${id}`;
      this.isLoaded = false;
      this.serverError = null;

      await apiCallTrue({ url })
        .then((response) => {
          this.offer = response.data.data;
        })
        .catch((error) => {
          console.log("ERROR", error);
          showNotify("error", error);
          this.serverError = error.message;
        })
        .finally(() => {
          this.isLoaded = true;
        });
    },
  },
  mounted() {
    // Vue.use(wysiwyg, {});
    const { id } = this.$route.params;
    this.getOffer(id);
  },
};
</script>

<style lang="scss" scoped>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
textarea.show-offer-comment {
  border: 1px solid #e6e6e6;
  width: 100%;
  min-height: 128px;
}

.main-invest-container {
  .v-list.danse__list_item {
    > .v-list-item {
      min-height: 30px;
    }
  }
}
.about-main,
.buisnes-main {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-top: 20px;
}
.about-main > div:first-child,
.buisnes-main > div:first-child {
  flex-grow: 1;
  padding-right: 10px;
}

.about-main > div:last-child,
.buisnes-main > div:last-child {
  min-width: 364px;
}
.fly-panel {
  top: 0;
  position: sticky;
}
table.table-buisnes-options {
  width: 100%;
  border-collapse: collapse;
}

table.table-buisnes-options tr {
  border-top: 1px solid #d8d8d8;
}

table.table-buisnes-options tr:nth-child(2n-2) {
  background-color: #fbfbfb;
}

.finance-layout > div {
  width: 50%;
}

.finance-layout table > tbody > tr > td:first-child {
  min-width: 185px;
}

.main-info-wrap {
  columns: 2;
  > .main-info-item {
    opacity: 1;
  }
  // padding: 16px;
  // text-align: left;
  // display: flex;
  // flex-wrap: wrap;
  // h2 {
  //   min-width: 100%;
  //   width: 100%;
  // }

  // &--compact {
  //   background: #fff;
  //   padding: 16px;
  //   border-radius: 5px;
  //   box-shadow: 0 0 10px #aaa;

  //   .main-info-item {
  //     max-width: 100%;
  //     flex-basis: 100%;
  //   }
  //   .main-info-wrap {
  //     padding-top: 8px;
  //   }
  // }

  // .v-divider {
  //   margin: 8px 0;
  // }

  // &-wrap {
  //   display: flex;
  //   flex-wrap: wrap;
  //   padding-top: 24px;
  // }

  // &-item {
  //   max-width: 49%;
  //   min-width: 49%;

  //   &:nth-child(2n + 2) {
  //     margin-left: 2%;
  //   }
  // }
}

@media screen and (max-width: 1200px) {
  .finance-layout {
    flex-wrap: wrap;
  }
  .finance-layout > div {
    width: 100%;
  }
}
</style>
